/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react'
import { useLocation, matchPath } from 'react-router-dom'

const whitelist = THEME_CONFIG.useSecondBackground

export var useBg = null

const useWhiteBg = () => {
  const { pathname } = useLocation()
  const [shouldUseWhiteBg, setShouldUseWhiteBg] = useState(null)

  useEffect(() => {
    const matches = matchPath(pathname, whitelist)?.path
    const isInList = whitelist.includes(matches)
    setShouldUseWhiteBg(isInList)
    useBg = isInList

    window.addEventListener('background-color', (event: any) => {
      setShouldUseWhiteBg(event.detail.shouldUseWhiteBg)
      useBg = event.detail.shouldUseWhiteBg
    })
  }, [pathname])

  return shouldUseWhiteBg
}

export default useWhiteBg
